export default __webpack_public_path__ + "static/media/explore_destination_img6.f0a25b94.jpg";